module.exports = __webpack_public_path__ + "assets/img/logo.d85803c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 1